import React from "react";
import useFormError from "../../hooks/useFormError";
import ProDropDown from "./ProDropDown";
import ProInputText from "./ProInputText";
import _ from "lodash"


const ProAddress = ({states, formik, error, disabled})=>{ 
   
   const handlechange = (e)=>{       
  
       formik.setFieldValue("model", { ...formik.values.model, 
            address:{...formik.values.model.address, [e.target.id]: _.isObject(e.target.value)? e.target.value: _.trimStart(e.target.value) }}); 
   } 
   const getFormErrorMessage = useFormError(formik);
   const disabledClass = disabled?"p-disabled":"";   

   if(_.get(formik.values.model, "address"))
    return(
        <div className={disabledClass}>       
            <ProInputText id ="addressLine1" labelText = "Address Line 1" value={formik.values.model.address.addressLine1 || ''} onChange={handlechange} required/>      
            <ProInputText id ="addressLine2" labelText = "Address Line 2" value={formik.values.model.address.addressLine2 || ''} onChange={handlechange}/>
            <ProInputText id ="city" labelText = "City" value={formik.values.model.address.city || ''} onChange={handlechange} required/>     
            <div className="p-grid">  
            <ProDropDown id="state"  value={formik.values.model.address.state}
                            style={{ width: "100%", marginBottom: "10px" }}  onChange= {handlechange}
                            options={states}  optionLabel="code" placeholder="State" required
                        />  
            <ProInputText id ="zipCode" labelText = "Zip-Code" rowCount = {2} value={formik.values.model.address.zipCode || ''} onChange={handlechange} required/>                 
            </div>
        <div>
        {getFormErrorMessage && getFormErrorMessage(error)}
      </div>
        </div>
    )
 else 
    return <React.Fragment></React.Fragment>
}

export default ProAddress;